"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpecialUrl = void 0;
const startsWithSpecialUrls = ['#', 'tel:', 'mailto:', 'javascript:'];
const regex = new RegExp(`^(${startsWithSpecialUrls.join('|')})`);
function isSpecialUrl(url) {
    return regex.test(url) || url === '';
}
exports.isSpecialUrl = isSpecialUrl;
